import React from "react";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartTooltip,
  ChartAxisDefaults,
  ChartLegend,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
} from '@progress/kendo-react-charts';

interface Props {
  data: any;
}

export default (props: Props) => {
  const sourceColor = (source: string) => {
    // todo
    if (source === 'MAS' || source === 'MASUNO') return '#365cdf';
    if (source === 'BEES') return '#fff000';
    if (source === 'CHS') return 'grey';
    if (source === 'TEL') return 'orange';
    return '';
  }

  return (
    <Chart transitions={false} style={{height: '4.5em'}}>
      <ChartTooltip shared={true} />
      <ChartLegend position="bottom" orientation="horizontal" visible={false} />
      <ChartCategoryAxis>
        <ChartCategoryAxisItem majorGridLines={{ visible: false }} />
      </ChartCategoryAxis>
      <ChartAxisDefaults majorGridLines={{visible: false}} narrowRange={false} visible={false}/>
      <ChartSeries>
        {props.data.map((x: any, key: number) => {
          return <ChartSeriesItem
            key={key}
            color={sourceColor(x.source)}
            type="bar"
            name={x.source}
            stack={{ type: '100%' }}
            data={[x.percentage]}
          />
        })}
      </ChartSeries>
    </Chart>
  );
};
